<template>
  <div>
    <footer>
      <div class="foot wrap">
        <div class="f-logo">
          <a
            href="http://bszs.conac.cn/sitename?method=show&id=105CF0D175436823E053012819AC18E5"
            target="_blank"
          >
            <img src="@/assets/images/flogo.png" alt="" />
          </a>
        </div>
        <div class="copyright pc">
          <div class="row mgb-10">
            <p>
              版权所有：江苏省产品质量监督检验研究院 Copyright@ 2011-2026
              技术支持：
              <a href="https://www.bbcxwl.com" target="_blank">辰星科技</a>
            </p>
          </div>
          <div class="row mgb-10 flex flex-center justify-center">
            <div class="flex flex-center justify-center">
              <!-- <img src="~@/assets/images/icp.png" style="margin-right: 5px" /> -->
              <a href="https://beian.miit.gov.cn/" target="_blank">
                ICP备案号：苏ICP备12068564号-7
              </a>
            </div>

            <div
              class="flex flex-center justify-center"
              style="margin-left: 20px"
            >
              <img src="~@/assets/images/icp.png" style="margin-right: 5px" />
              <a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=32010402002490"
                rel="noreferrer"
                target="_blank"
                >苏公网安备32010402002490号</a
              >
            </div>
          </div>
        </div>
        <div class="copyright mobile">
          <div class="row mgb-10">
            <div class="min-w-330">
              <strong style="font-weight: bold; color: #6f6f6f">
                版权所有：江苏省产品质量监督检验研究院 Copyright@
                2011-2026</strong
              >
            </div>
            <div>
              技术支持：<a href="https://www.bbcxwl.com" target="_blank"
                >辰星科技</a
              >
            </div>
          </div>
          <div class="row">
            <div class="min-w-330">
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14010702070032"
                target="_blank"
                class="flex flex-center"
              >
                <img
                  src="~@/assets/images/icp.png"
                  style="margin-right: 5px"
                />ICP备案号：苏ICP备12068564号-7</a
              >
            </div>

            <div class="min-w-330">
              <a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=32010402002490"
                target="_blank"
                class="flex flex-center"
              >
                <img
                  src="~@/assets/images/icp.png"
                  style="margin-right: 5px"
                />苏公网安备32010402002490号</a
              >
            </div>
          </div>
        </div>
        <div class="w-dropdown J_dropdown">
          <input class="dropdown-sel" value="常用链接" readonly />
          <ul class="dropdown-option">
            <template v-if="arr1.length > 0">
              <li v-for="item in arr1" :key="item.id">
                <a :href="item.url" target="_blank">{{ item.name }}</a>
              </li>
              <li class="divider"></li>
            </template>

            <template v-if="arr2.length > 0">
              <li v-for="item in arr2" :key="item.id">
                <a :href="item.url" target="_blank">{{ item.name }}</a>
              </li>
              <li class="divider"></li>
            </template>

            <template v-if="arr3.length > 0">
              <li v-for="item in arr3" :key="item.id">
                <a :href="item.url" target="_blank">{{ item.name }}</a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      flag: false,
      toggleFlag: false,

      rightPicList: [],

      bottomPicList: [],

      arr1: [],
      arr2: [],
      arr3: [],
    };
  },
  methods: {
    toggle() {
      this.toggleFlag = !this.toggleFlag;
    },
    getLinkList() {
      this.$request("/web/getCylj", "GET").then((res) => {
        let { arr1, arr2, arr3 } = res.data.data;
        this.arr1 = arr1;
        this.arr2 = arr2;
        this.arr3 = arr3;
      });
    },

    getLbt() {
      this.$request("/media/getLbt", "GET", {
        type: "02",
        sybh: 1,
      }).then((res) => {
        this.rightPicList = res.data.data.slice(-1);
        this.bottomPicList = res.data.data.slice(0, 3);
      });
    },
  },
  mounted() {
    this.getLbt();
    this.flag = JSON.parse(localStorage.getItem("flag"));
    this.getLinkList();

    $(function () {
      $(".J_dropdown").each(function () {
        var _this = $(this);
        var $sel = _this.find(".dropdown-sel");
        var $option = _this.find(".dropdown-option");
        var $as = $option.children("li").children("a");
        var index = -1;

        $sel.click(function (e) {
          e.stopPropagation();
          $option.toggle();
        });

        const excludeElement = document.getElementById("toggle");
        $(document).click(function (event) {
          if (
            excludeElement &&
            (event.target === excludeElement ||
              excludeElement.contains(event.target))
          ) {
            // 如果是排除的元素，不执行任何操作
            return;
          } else {
            $option.hide();
          }
        });
      });
    });
  },
};
</script>

<style lang="less" scoped>
.right-nav {
  position: fixed;
  right: 2.5%;
  top: 400px;
  z-index: 99;

  li {
    margin: 20px 0;
  }
}

footer {
  background-color: #fff;
  margin-top: 45px;
  border-top: 3px solid #1076bf;
  color: #888888;
  position: relative;
  z-index: 20;

  .foot {
    position: relative;
    font-size: 14px;

    display: flex;
    align-items: center;
    justify-content: center;

    .f-logo {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    .picbottom {
      margin-right: 100px;
      display: flex;
      div {
        margin: 0 5px;
        width: 95px;
        height: 95px;
      }
    }

    .copyright {
      padding: 40px 0;

      .row {
        text-align: center;
      }

      .mgb-10 {
        margin-bottom: 15px;
      }

      .min-w-330 {
        min-width: 350px;
      }
    }

    .w-dropdown {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    .w-dropdown:before {
      content: "";
      border-top: 7px solid #c9c9c9;
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -2px;
      z-index: -1;
    }

    .w-dropdown .dropdown-sel {
      display: block;
      color: #666666;
      cursor: pointer;
      font-style: normal;
      border: 1px solid #e0e0e0;
      outline: line;
      font-size: 12px;
      padding: 5px 10px;
      line-height: 1.5;
      border-radius: 3px;
      width: 150px;
      box-sizing: border-box;
    }

    .w-dropdown .dropdown-sel:focus {
      outline: none;
    }

    .w-dropdown .dropdown-sel:hover {
      border: 1px solid #abb9c2;
    }

    .w-dropdown ul {
      display: none;
      width: 216px;
      border: 1px solid #c0c5cc;
      background-color: #ffffff;
      position: absolute;
      z-index: 999;
      margin-top: -1px;
      top: auto;
      bottom: 100%;
      right: 0;
    }

    .w-dropdown ul li {
      height: 28px;
      line-height: 28px;

      &.divider {
        height: 1px;
        margin: 2px;
        overflow: hidden;
        background-color: #e5e5e5;
      }
    }

    .w-dropdown ul li a {
      display: block;
      height: 28px;
      color: #999;
      text-decoration: none;
      padding-left: 10px;
      padding-right: 10px;
    }

    .w-dropdown ul li a:hover {
      color: #333;
      background-color: #f0f0f0;
    }

    .w-dropdown ul li a.hover {
      color: #333;
      background-color: #f0f0f0;
    }
  }
}

.notice-video video {
  position: relative;
  z-index: 1;
}

.mobile {
  display: none;
}

@media screen and (max-width: 998px) {
  .pc {
    display: none !important;
  }

  .mobile {
    display: block !important;

    .row {
      flex-direction: column;
    }

    .min-w-330 {
      margin-bottom: 15px;
      a {
        justify-content: center;
      }
    }
  }

  footer .foot {
    flex-direction: column;
  }

  footer .foot .picbottom {
    margin-right: 0;
  }
}
</style>